<template>
    <div>
        <el-dialog align-center v-model="state.dialogVisible" :title="title" :width="state.type === 'add' ? 800 : 400"
            draggable>
            <!-- 人员基本信息 -->
            <div class="userAdd_man">
                <el-form ref="ruleForm" label-width="auto" :model="state.form" :rules="rules" class="userFrom">
                    <el-row v-if="state.type === 'add'">
                        <el-col :span="12" style="margin-bottom: 20px;">
                            <el-form-item v-if="state.type === 'add'" :label="t('deviceForm.template')" prop="device_id">
                                <el-select v-model="state.form.device_id" :placeholder="t('common.pleaseSelect')">
                                    <el-option v-for="(item, index) in state.templateOptions" :key="index"
                                        :label="item.label" :value="item.value" />
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12" style="margin-bottom: 20px;">
                            <el-form-item v-if="state.type === 'add'" :label="t('field.deviceCode')" prop="code">
                                <el-input v-model="state.form.code" />
                            </el-form-item>
                        </el-col>
                        <el-col :span="12" style="margin-bottom: 20px;">
                            <el-form-item v-if="state.type === 'add'" :label="t('field.manufacturer')" prop="manufacturer">
                                <el-input v-model="state.form.manufacturer" />
                            </el-form-item>
                        </el-col>
                        <el-col :span="12" style="margin-bottom: 20px;">
                            <el-form-item v-if="state.type === 'add'" :label="t('field.deviceName')" prop="title">
                                <el-input v-model="state.form.title" />
                            </el-form-item>
                        </el-col>
                        <el-col :span="12" style="margin-bottom: 20px;">
                            <el-form-item v-if="state.type === 'add'" :label="t('field.model')" prop="model">
                                <el-input v-model="state.form.model" />
                            </el-form-item>
                        </el-col>
                        <el-col :span="12" style="margin-bottom: 20px;">
                            <el-form-item :label="t('field.maintenanceTime')" prop="created_at">
                                <el-date-picker style="width: 100%;" v-model="state.form.created_at"
                                    type="date" value-format="YYYY-MM-DD" :placeholder="t('field.maintenanceTime')"
                                    />
                            </el-form-item>
                        </el-col>
                        <el-col :span="12" style="margin-bottom: 20px;">
                            <el-form-item :label="t('deviceList.workDuration')" prop="time">
                                <el-input-number v-model="state.form.time" />
                            </el-form-item>
                        </el-col>
                        <el-col :span="12" style="margin-bottom: 20px;">
                            <el-form-item :label="t('field.initialWorkHours')" prop="chu_time">
                                <el-input-number v-model="state.form.chu_time" />
                            </el-form-item>
                        </el-col>
                        <el-col :span="12" style="margin-bottom: 20px;">
                            <el-form-item :label="t('deviceForm.workKm')" prop="kilometer">
                                <el-input-number v-model="state.form.kilometer" />
                            </el-form-item>
                        </el-col>
                        <el-col :span="12" style="margin-bottom: 20px;">
                            <el-form-item :label="t('deviceForm.initialWorkKm')" prop="chu_kilometer">
                                <el-input-number v-model="state.form.chu_kilometer" />
                            </el-form-item>
                        </el-col>
                        <el-col :span="12" style="margin-bottom: 20px;">
                            <el-form-item :label="t('field.status')" prop="status">
                                <el-switch v-model="state.form.status" :active-value="1" :inactive-value="0"
                                    :active-text="t('status.available')" :inactive-text="t('status.warehouse')" />
                            </el-form-item>
                        </el-col>


                        <el-col :span="24" style="margin-bottom: 20px;">
                            <el-form-item :label="t('deviceForm.fullPhoto')">
                                <el-upload
                                    v-model:file-list="state.pictureList"
                                    :action="state.uploadUrl"
                                    :headers="state.headers"
                                    list-type="picture-card"
                                    :on-success="onSuccess"
                                    :limit="3"
                                    :accept="acceptTypes"
                                    :before-upload="beforeUpload"
                                    :on-preview="handlePictureCardPreview"
                                >
                                    <el-icon><Plus /></el-icon>
                                </el-upload>
                            </el-form-item>
                        </el-col>
                        <el-col :span="24" style="margin-bottom: 20px;">
                            <el-form-item :label="t('deviceForm.nameplatePhoto')">
                                <el-upload
                                    v-model:file-list="state.nameplateList"
                                    :action="state.uploadUrl"
                                    :headers="state.headers"
                                    list-type="picture-card"
                                    :on-success="onSuccess"
                                    :limit="3"
                                    :accept="acceptTypes"
                                    :before-upload="beforeUpload"
                                    :on-preview="handlePictureCardPreview"
                                >
                                    <el-icon><Plus /></el-icon>
                                </el-upload>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-col v-if="state.type === 'addKm'" :span="24">
                        <el-form-item :label="t('deviceForm.kmToAdd')" prop="title">
                            <el-input-number v-model="state.form.kilometer" />
                        </el-form-item>
                    </el-col>
                </el-form>
            </div>
            <template #footer>
                <div class="dialog-footer">
                    <el-button @click="state.dialogVisible = false">{{ t('common.cancel') }}</el-button>
                    <el-button type="primary" @click="submit">
                        {{ t('common.confirm') }}
                    </el-button>
                </div>
            </template>
        </el-dialog>
    </div>
</template>

<script setup>
import {
    onMounted,
    reactive,
    ref,
    nextTick,
    defineEmits,
    defineProps,
    defineExpose,
    toRaw
} from "vue";
import { ElMessage } from "element-plus";
import { saveApi, detailApi } from "@/api/system/device";
import { pageListApi } from "@/api/system/template";
import { globalConfig } from "@/configs/globalConfig"
import { t } from "@/composables/usePageI18n.js";

const emit = defineEmits([]);
const props = defineProps({
    title: {
        type: String,
        default: "设备新增",
    },
    row: {
        type: Object,
        default: () => { },
    }
});

const rules = reactive({
    device_id: [{ required: true, message: "请选择模板", trigger: "blur" }],
    code: [{ required: true, message: "请输入機號", trigger: "blur" }],
    title: [{ required: true, message: "请输入设备名称", trigger: "blur" }],
    model: [{ required: true, message: "请输入机型", trigger: "blur" }],
});

const state = reactive({
    dialogVisible: false,
    type: 'add',
    pictureList: [],
    nameplateList: [],
    uploadUrl: globalConfig.uploadUrl,
    headers: {
        "Authorization": "Bearer " + localStorage.getItem("token"),
    },
    form: {
        "id": 0,
        "code": "",
        "title": "",
        "device_id": null,
        "kilometer": 0,
        "time": 0,
        "chu_kilometer": 0,
        "chu_time": 0,
        "manufacturer": "",
        "model": '',
        "status": 0,
        "picture": '',
        "nameplate": '',
        "created_at": ''
    },
    templateOptions: []
});

const acceptTypes = ref('image/*')  // 只接受图片类型
// 上传前验证
const beforeUpload = (file) => {
  const isImage = file.type.startsWith('image/')
  if (!isImage) {
    ElMessage.error('只能上传图片文件!')
    return false
  }
  return true
}

const onSuccess = (response, file, fileList) => {
}

const getTemplateOptions = () => {
    const params = JSON.stringify({
        "page": 1,
        "limit": 1000,
        keywords: ''
    })
    pageListApi(params).then(res => {
        if (res?.code === 200) {
            state.templateOptions = res?.data.map(i => {
                return {
                    label: i.title,
                    value: i.id
                }
            })
        }
    })
}

const getDeviceInfo = (row = {}) => {
    if (row?.id) {
        const params = JSON.stringify({
            "id": row.id
        })
        detailApi(params).then(res => {
            if (res?.code !== 200) return
            state.form = {
                ...res.data,
                device_id: res.data.deviceId ?? null,
                chu_kilometer: res.data.chuKilometer ?? 0,
                chu_time: res.data.chuTime ?? 0,
            }
            state.pictureList = JSON.parse(res.data.picture ?? '[]')
            state.nameplateList = JSON.parse(res.data.nameplate ?? '[]')
        })
    } else {
        state.form = {
            "id": 0,
            "code": "",
            "title": "",
            "device_id": null,
            "kilometer": 0,
            "time": 0,
            "chu_kilometer": 0,
            "chu_time": 0,
            "manufacturer": "",
            "model": '',
            "status": 0,
            "picture": '',
            "nameplate": '',
            "created_at": ''
        }
    }

}

const open = (row, type) => {
    state.type = type ?? 'add'
    getTemplateOptions()
    getDeviceInfo(row)
    state.dialogVisible = true;
};

const ruleForm = ref(null)
const submit = () => {
    ruleForm.value.validate((valid) => {
        if (valid) {
            const params = state.type === 'add' ? {
                "id": state.form.id,
                "code": state.form.code,
                "title": state.form.title,
                "device_id": state.form.device_id,
                "manufacturer": state.form.manufacturer,
                "model": state.form.model,
                "status": state.form.status,
                "kilometer": state.form.kilometer,
                "chu_kilometer": state.form.chu_kilometer,
                "chu_time": state.form.chu_time,
                "time": state.form.time,
                "created_at": state.form.created_at,
                "picture": JSON.stringify(toRaw(state.pictureList).map(i => { return { url: i.response?.data } })),
                "nameplate": JSON.stringify(toRaw(state.nameplateList).map(i => { return { url: i.response?.data } }))
            } : {
                "id": state.form.id,
                "kilometer": state.form.kilometer,
            }
            saveApi(JSON.stringify(toRaw(params))).then(res => {
                if (res?.code === 200) {
                    ElMessage.success('操作成功')
                    state.dialogVisible = false
                    state.form = {
                        "id": 0,
                        "code": "",
                        "title": "",
                        "device_id": null,
                        "kilometer": 0,
                        "manufacturer": "",
                        "model": '',
                        "status": 0,
                        "time": 0,
                        "chu_kilometer": 0,
                        "chu_time": 0,
                        "picture": '',
                        "nameplate": '',
                        "created_at": ''
                    }
                    emit('refresh')
                }else{
                    ElMessage.success(res.msg)
                }
            })
        } else {
            return false;
        }
    });
};

onMounted(() => {
    console.log(globalConfig.uploadUrl);

    try {
        if (row?.id) {
            getDeviceInfo();
        } else {
            form.id = 0
        }
    } catch (error) {

    }
});

defineExpose({ open, state });
</script>

<style lang="less" scoped>
.userAdd_man {
    min-height: 200px;
    max-height: 600px;
    overflow: auto;
    padding: 0 30px;
}

.userFrom {
    display: flex;
    flex-wrap: wrap;
    // gap: 20px;
    /* 可选，添加网格项之间的间隙 */
    // grid-template-columns: repeat(2, 1fr);
}

.el-form-item {
    margin-bottom: 0;
}

.tree_man {
    padding: 0 30px;
}
</style>
